<script setup lang="ts">
import { defineProps } from 'vue';

import Button from 'primevue/button';

import { useCopyCalculation } from '../composables/useCopyCalculation';

const props = defineProps<{
  calculationId: number;
}>();

const { isLoading, copyCalculation } = useCopyCalculation(() => props.calculationId);
</script>

<template>
  <Button
    class="!p-2"
    size="small"
    severity="secondary"
    outlined
    :loading="isLoading"
    title="Stwórz kopię kalkulacji"
    @click="copyCalculation"
  >
    <i class="pi pi-copy"></i>
  </Button>
</template>
